export default function setItemInLocalStorage({
  key,
  value,
}: {
  key: string;
  value: string;
}) {
  localStorage.setItem(key, value);
}
